/**
 * Удаляет параметр из адресной стороки
 *
 * @param {String} param
 */
export function removeQueryParameter(param: string) {
    if (!new RegExp(`${param}=`).test(window.location.search)) {
        return;
    }

    /* istanbul ignore next */
    if (!window.history) {
        return;
    }

    /* istanbul ignore next */
    window.history.replaceState(
        null,
        document.title,
        filterQueryString(window.location.href, param)
    );
}

/**
 * Удаляет get параметр из href
 *
 * @param href
 * @param param
 */
export function filterQueryString(href: string, param: string) {
    const [_href, searchString] = href.split('?');

    const searchParams = searchString
        .split('&')
        .filter((part) => !new RegExp(`${param}=`).test(part));

    return _href + (searchParams.length ? `?${searchParams.join('&')}` : '');
}

/**
 * Получает карту параметров из текущего урла
 */
export function getQueryParamsMap(): Record<string, string | undefined> {
    /* istanbul ignore next */
    return extractQueryParamsFromURL(window.location.search);
}

/**
 * Создает карту параметров из переданной строки урла
 *
 * @param url
 */
export function extractQueryParamsFromURL(
    url: string
): Record<string, string | undefined> {
    return url
        .replace(/^\/?\?/, '')
        .split('&')
        .filter((s) => s)
        .reduce((acc: Record<string, string | undefined>, param) => {
            const [key, value] = param.split('=');
            acc[key] = value;
            return acc;
        }, {});
}

/**
 * http_build_query
 *
 * @param obj
 */
export function build_query(obj: Record<string, string | number>): string {
    return (
        Object.keys(obj)
            .map((key) => `${key}=${obj[key]}`)
            .join('&') || ''
    );
}

/**
 * Добавляет query-параметры к строке запроса (с поиском "?")
 *
 * @param url
 * @param query_params
 */
export function addQueryParameters(
    url: string,
    query_params: Record<string, string | number>
) {
    return joinQueryParameters(url, build_query(query_params));
}

/**
 * Приклеивает строку query-параметров к строке запроса (с поиском "?")
 *
 * @param url
 * @param query_string
 */
export function joinQueryParameters(url: string, query_string: string) {
    const delimiter = url.indexOf('?') === -1 ? '?' : '&';
    return query_string ? url + delimiter + query_string : url;
}

/**
 * Подмерживает параметры к урлу, с приоритетом последних
 *
 * @param url
 * @param extraParams
 */
export function mergeQueryParameters(
    url: string,
    extraParams: string | undefined | Record<string, string | number>
) {
    if (
        !extraParams ||
        (typeof extraParams === 'object' &&
            Object.keys(extraParams).length === 0)
    ) {
        return url;
    }

    const idx = url.indexOf('?');
    let mergedParams =
        typeof extraParams === 'string'
            ? extractQueryParamsFromURL(extraParams)
            : extraParams;

    let pathString = url;
    if (idx > -1) {
        pathString = url.substr(0, idx);
        const queryPart = url.substr(idx);

        mergedParams = Object.assign(
            {},
            extractQueryParamsFromURL(queryPart),
            mergedParams
        );
    }

    return addQueryParameters(pathString, mergedParams as Record<string, any>);
}
